import React from 'react';
import { IIcon } from '../interfaces';

function SuccessAttention({ onClick, type, color, className, styles }: IIcon.Props) {

    return (
        <i className={`fa${type ? type?.substr(0,1) : "s"} fa-check-circle ${className ?? ""} text-${color}`} onClick={onClick} style={styles}> </i>
    )
}

export default SuccessAttention;